import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { KlSweetAlertService } from "./message/kl-sweet-alert.service";

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  // TODO: Buraya dinamik olarak olusturulan confirmboxlarin servisi enjekte edilecek
  constructor(private injector: Injector) {}
  handleError(error: any): void {
    // get the error message
    const message = error.message ? error.message : error.toString();
    const alertService = this.injector.get(KlSweetAlertService);
    alertService.alertError(
      {
        title: "error",
      },
      error,
      false,
      () => {},
      () => {}
    );
    throw error;
  }
}
